import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { installChime } from "@/lib/chime";
import { subscribePush } from "@/lib/push";

/**
 * Silent push re-registration. Never prompts: only (re)subscribes when the user
 * has already granted notification permission. The explicit opt-in lives in
 * PushOptInCard (portal) so the permission dialog is always tied to a tap.
 */
export default function PushRegistrar() {
  const { user } = useAuth();
  const [attempted, setAttempted] = useState(false);

  useEffect(() => { if (user?.id) installChime(); }, [user?.id]);

  useEffect(() => {
    if (attempted || !user?.id) return;
    if (!("Notification" in window) || Notification.permission !== "granted") return;
    setAttempted(true);
    const t = setTimeout(() => {
      subscribePush({ promptIfNeeded: false }).catch((e) => console.debug("[push] silent re-subscribe skipped:", e?.message || e));
    }, 2000);
    return () => clearTimeout(t);
  }, [user?.id, attempted]);

  return null;
}
